import { render, staticRenderFns } from "./CasePojectOverview.vue?vue&type=template&id=59619648"
import script from "./CasePojectOverview.vue?vue&type=script&lang=js"
export * from "./CasePojectOverview.vue?vue&type=script&lang=js"
import style0 from "./CasePojectOverview.vue?vue&type=style&index=0&id=59619648&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports